import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import { DateTime } from 'luxon';
import {
  AllocationType,
  FindAllAllocationsSort,
  type AllocationsControllerFindAllData,
  type FindAllAllocationsFilterDto,
} from '@carvia/ros-client-types';
import { Order } from '@/entities/pagination/order.enum';

export const UNASSIGNED_LONG_TRANSFER_MIN_TRAVEL_MINUTES = 60;

export const useGetUnassignedLongTransfersQuery = (
  currentStationId: MaybeRefOrGetter<string | undefined>,
  searchQuery: MaybeRefOrGetter<string> = '',
  bookingNumberQuery: MaybeRefOrGetter<number | undefined> = undefined,
) => {
  return computed<NonNullable<AllocationsControllerFindAllData['query']>>(() => {
    const stationId = toValue(currentStationId);
    const search = toValue(searchQuery);
    const bookingNumber = toValue(bookingNumberQuery);
    const baseFilter: FindAllAllocationsFilterDto = {
      types: [AllocationType.TRANSFER_DELIVERY, AllocationType.TRANSFER_RETURN],
      hasDriver: false,
      minTravelMinutes: UNASSIGNED_LONG_TRANSFER_MIN_TRAVEL_MINUTES,
      isActive: true,
      endDateAfter: DateTime.now().toJSDate(),
      query: search || undefined,
      bookingNumbers: bookingNumber ? [bookingNumber] : undefined,
    };
    const filter = stationId
      ? [
          { ...baseFilter, pickupResponsibleStationIds: [stationId] },
          { ...baseFilter, dropoffResponsibleStationIds: [stationId] },
          { ...baseFilter, carStationIds: [stationId] },
        ]
      : [baseFilter];
    return {
      filter,
      sort: [FindAllAllocationsSort.START_DATE],
      order: Order.ASC,
    };
  });
};
